import { ApiDownloadFile } from "@/api";
import { ENTRY, WX } from "@/config";
import { getFileName } from "@/hooks/useFinance";
import { showSuccessToast, showToast } from "vant";
import { isWeComMobile } from "..";

export enum MSG_TYPE {
  TEXT = "text",
  FILE = "file",
  IMAGE = "image",
}

export const wxSend = (e: string, msgtype = MSG_TYPE.TEXT) => {
  console.group("发送信息到对话框", msgtype);
  console.log(e);
  let data: any = { msgtype, enterChat: false };
  if (msgtype == MSG_TYPE.TEXT) {
    //文本内容
    data.text = { content: e + "\n" };
  } else if (msgtype == MSG_TYPE.FILE) {
    //图片的素材id
    data.file = { mediaid: e };
  } else if (msgtype == MSG_TYPE.IMAGE) {
    data.image = { mediaid: e };
  }
  console.log(data);

  wx?.invoke("sendChatMessage", data, function (res: any) {
    // showSuccessToast("发送成功");
  });
  console.groupEnd();
};

export const wxPhone = (e: string) => {
  console.log(e);
  if (/android|webos|iphone|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) {
    window.location.href = `tel:${e}`;
  } else {
    showToast("当前设备不支持，请在手机端拨打");
  }
};

export const wxPayment = (totalFee: number) => {
  console.log("发起收款", totalFee);
  wx.invoke(
    "createExternalPayment",
    {
      paymentType: 0, //收款方式
      totalFee: totalFee * 100, //收款金额，单位为分
      description: "可乐一罐", //收款说明
    },
    function (res: any) {
      if (res.errmsg == "fail_no permission") {
        showToast("发送失败");
      }
      console.log(res);
    }
  );
};

/** 打开群聊 */
export const wxOpen = (chatId: string) => {
  const data = { chatId };
  wx.invoke("openExistedChatWithMsg", data, function (res: any) {
    console.log(res);
  });
};

/** 下载文件*/
export const wxDownload = async (name: string, url: string) => {
  const fileName = getFileName(name, url);
  const link = document.createElement("a");
  const body = document.querySelector("body");
  if (body) {
    if (isWeComMobile()) {
      link.href = url;
    } else {
      const res = await getFileBlob(fileName, url);
      link.href = URL.createObjectURL(res);
    }
    link.download = fileName;
    link.style.display = "none";
    body.appendChild(link);
    link.click();
    body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }
};

export const getFileBlob = async (fileName: string, fileUrl: string) => {
  const res = await ApiDownloadFile({ fileName, fileUrl });
  console.log(res, "12res");
  return res;
};
